import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SplitByCapitalLetterPipePipe } from "@shared/pipes/split-by-capital-letter-pipe.pipe";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { AnnualStatementRecord } from "@models/annual-statements/annual-statement-record";
import { AnnualStatementStatus } from "@models/annual-statements/annual-statement-enums";

@Component({
  selector: 'app-ag-annual-status',
  standalone: true,
  imports: [
    SplitByCapitalLetterPipePipe,
  ],
  templateUrl: 'ag-annual-status.component.html',
  styleUrl: 'ag-annual-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgAnnualStatusComponent implements ICellRendererAngularComp {
  @Input() status: AnnualStatementStatus | null | undefined;

  readonly AnnualStatementStatus = AnnualStatementStatus;

  agInit(params: ICellRendererParams<AnnualStatementStatus, AnnualStatementStatus>): void {
    this.updateCell(params);
  }

  refresh(params: ICellRendererParams<AnnualStatementStatus, AnnualStatementStatus>): boolean {
    return this.updateCell(params);
  }

  updateCell(params: ICellRendererParams<AnnualStatementStatus, AnnualStatementStatus>): boolean {
    this.status = params.value as number;

    return true;
  }
}
